.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--navbar-height);
  background: rgba(10, 10, 15, 0.85);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border);
  z-index: var(--z-sticky);
}

.inner {
  max-width: 1400px;
  margin: 0 auto;
  height: 100%;
  padding: 0 var(--space-lg);
  display: flex;
  align-items: center;
  gap: var(--space-xl);
}

.logo {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  text-decoration: none;
  color: var(--text-primary);
}

.logoIcon {
  font-size: 1.5rem;
  color: var(--accent-cyan);
  text-shadow: 0 0 10px var(--glow-cyan);
}

.logoText {
  font-family: var(--font-heading);
  font-size: var(--text-lg);
  font-weight: 700;
  letter-spacing: 2px;
  color: var(--accent-cyan);
}

.navLinks {
  display: flex;
  align-items: center;
  gap: var(--space-lg);
  flex: 1;
}

.navLink {
  font-family: var(--font-heading);
  font-size: var(--text-xs);
  letter-spacing: 3px;
  color: var(--text-muted);
  text-decoration: none;
  padding: var(--space-xs) var(--space-sm);
  border: 1px solid transparent;
  border-radius: var(--radius-sm);
  transition: all var(--transition-fast);
}

.navLink:hover {
  color: var(--accent-cyan);
  border-color: var(--border-accent);
  background: var(--glow-cyan);
}

.navLink.active {
  color: var(--accent-cyan);
  border-color: var(--border-accent);
}

.terminal {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  font-family: var(--font-code);
  font-size: var(--text-sm);
  color: var(--accent-cyan);
  margin-left: auto;
}

.terminalPrompt {
  opacity: 0.7;
}

.terminalCursor {
  width: 8px;
  height: 16px;
  background-color: var(--accent-cyan);
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
}

@media (max-width: 768px) {
  .terminal {
    display: none;
  }
  .navLink {
    letter-spacing: 1px;
  }
}
